// A member between two documents: routed but its destination document not yet
// created, or approved but its raw document not yet written. The card shows how
// long it has been so and, once the relay's normal window has passed, offers a
// Cancel that hands the member back to its actionable card (M220). Cancel is
// safe because the relay's one transaction refuses a member that is no longer
// approved, and every step before that transaction is if-absent.
import React from 'react';
import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { toMillis } from '../../../utils/timestamps';

// The reaper's staleness gate for an approved member: 600 seconds.
export const RELAY_WINDOW_MS = 10 * 60 * 1000;

function TransitionCard({ fileName, caption, since, now, onCancel }) {
  const sinceMillis = since ? toMillis(since) : 0;
  const ageMinutes = sinceMillis ? Math.floor((now - sinceMillis) / 60000) : 0;
  const overdue = Boolean(sinceMillis) && now - sinceMillis >= RELAY_WINDOW_MS;
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="subtitle2">{fileName}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {caption}{ageMinutes >= 1 ? ` (${ageMinutes} min)` : ''}
          </Typography>
          <CircularProgress size={16} sx={{ ml: 1 }} />
        </Box>
        {overdue && onCancel && (
          <>
            <Typography variant="caption" color="warning.main" sx={{ display: 'block', mt: 1 }}>
              Routing has taken longer than expected.
            </Typography>
            <Button size="small" variant="outlined" sx={{ mt: 1, alignSelf: 'flex-start' }} onClick={onCancel}>
              Cancel routing
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
}

export default TransitionCard;
